import React, { useEffect, useState } from 'react';

const RobotsTxt = () => {
  const [content, setContent] = useState('Loading robots.txt...');

  useEffect(() => {
        fetch(`${API}/robots.txt`)
      .then(res => res.text())
      .then(data => setContent(data))
      .catch(err => setContent('Error loading robots.txt'));
  }, []);

  return (
    <pre style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', padding: '20px' }}>
      {content}
    </pre>
  );
};

export default RobotsTxt;
